import { combineReducers } from 'redux';
import dashboardMaintenanceEnquiry, { IDMEState } from './dashboardMaintenanceEnquiry';

export interface IDashboardMaintenanceEnquiryState {
  dashboards: IDMEState;
  [name: string]: any;
}
const combined = combineReducers<IDashboardMaintenanceEnquiryState>({
  dashboards: dashboardMaintenanceEnquiry,
});

export default combined;
